import { DraggableFilterType } from '../../../../constants';

export enum FailedMessageFilterName {
  TransactionDateTime = 'transactionDateTime',
  TransportReferences = 'transportReferences',
  CarrierIds = 'carrierIds',
}

export enum FailedMessageTimeFilterName {
  TransactionDateTime = 'transactionDateTime',
}

export enum FailedMessageReportFieldName {
  Sc3 = 'sc3',
  Sc4 = 'sc4',
}

export const FAILED_MESSAGE_FILTER_TYPE_BY_NAME: Map<FailedMessageFilterName, DraggableFilterType> = new Map([
  [FailedMessageFilterName.TransactionDateTime, DraggableFilterType.CombinedRangeDatepicker],
  [FailedMessageFilterName.TransportReferences, DraggableFilterType.ChipsInput],
  [FailedMessageFilterName.CarrierIds, DraggableFilterType.ChipsInput],
]);
